// extracted by mini-css-extract-plugin
export const wrapper = "experience-module--wrapper--NmOmw";
export const title = "experience-module--title--1bIT6";
export const skewed = "experience-module--skewed--ai_CT";
export const container = "experience-module--container--1s0Pn";
export const highlighted = "experience-module--highlighted--IR1kH";
export const tabs = "experience-module--tabs--2aIFP";
export const tabList = "experience-module--tabList--iXxgz";
export const tabPanels = "experience-module--tabPanels--2kzLN";
export const tabPanel = "experience-module--tabPanel--24wZu";